import React, { useEffect } from 'react';
import { styled } from 'linaria/react';
import { FetchQRStatus, PayStatusSBP, getStatusInfo, getStatusText, getStatusNotice, useResultStore } from '@entities/payment';
import { NoticeType } from '@shared/config/notice';
import { Spinner } from '@shared/ui/atoms';
import { removeFirstSubstring } from '@shared/lib';
import { withTheme } from '@shared/lib/theme';
import { usePartner, Partners } from '@shared/lib/partner';
import { OperationDetailsRs } from '@root/api/ump-ewallet';
import { OperationStatus } from './OperationStatus';
import { InfoRowsList } from './InfoRowsList';
import { ServicesButton } from './ServicesButton';
import { useInfoRowsResult } from '../lib/useInfoRowsResult';
import FlocktoryBanner from './FlocktoryBanner';
interface PaymentStatusInfoProps {
  payStatus?: string;
  qrStatusData?: FetchQRStatus;
  receiptData?: Record<string, unknown>[];
  formattedDate?: string;
  operationDetails?: OperationDetailsRs;
}
const PaymentStatusInfo: React.FC<PaymentStatusInfoProps> = ({
  payStatus,
  qrStatusData,
  receiptData,
  formattedDate,
  operationDetails
}) => {
  const {
    setPayStatusStore
  } = useResultStore();
  const isSBP = Boolean(qrStatusData);
  const {
    partner
  } = usePartner();
  useEffect(() => {
    if (payStatus) {
      const status = getStatusNotice(isSBP, payStatus, operationDetails);
      setPayStatusStore(status as NoticeType);
      return;
    }
    if (operationDetails) {
      const status = getStatusNotice(isSBP, payStatus as string, operationDetails);
      setPayStatusStore(status as NoticeType);
    }
  }, [payStatus, operationDetails, isSBP, setPayStatusStore]);
  const sbpInfoRows = useInfoRowsResult({
    data: qrStatusData as FetchQRStatus,
    formattedDate: formattedDate as string,
    loadingComponent: <Spinner />,
    isSBP
  });
  const operationInfoRows = useInfoRowsResult({
    data: operationDetails as OperationDetailsRs,
    formattedDate: formattedDate as string,
    loadingComponent: <Spinner />,
    isSBP
  });
  const infoRows = isSBP ? sbpInfoRows : operationInfoRows;
  const status = getStatusNotice(isSBP, payStatus as string, operationDetails);
  const statusText = getStatusText(status as NoticeType);
  const statusInfo = getStatusInfo(status as NoticeType);
  const subtitle = removeFirstSubstring(operationDetails?.service?.serviceName || (status !== NoticeType.ERROR && qrStatusData?.paymentPurpose) as string, 'Услуга: ');
  return <ContentWrapper>
      <PaymentStatusInfoWrapper>
        <OperationStatus icon={statusInfo.icon} title={statusInfo.text || statusText} subtitle={subtitle} description={(status === NoticeType.ERROR && 'Повторите попытку позже') as string} />
        {payStatus !== PayStatusSBP.REJECTED && <InfoFinal>
            <InfoRowsList rows={infoRows} />
          </InfoFinal>}

        <ServicesButton payStatus={status as NoticeType} receiptData={receiptData} qrStatusData={qrStatusData} operationDetails={operationDetails} formattedDate={formattedDate} />
      </PaymentStatusInfoWrapper>
      {partner === Partners.DEFAULT && status !== NoticeType.ERROR && <FlocktoryBanner />}
    </ContentWrapper>;
};
export default PaymentStatusInfo;
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "ckcwaog",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.secondary;
export const PaymentStatusInfoWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "PaymentStatusInfoWrapper",
  class: "p1yekdp8",
  propsAsIs: false,
  vars: {
    "p1yekdp8-0": [_exp()]
  }
}));
export const InfoFinal = /*#__PURE__*/styled('div')({
  name: "InfoFinal",
  class: "iqpae7e",
  propsAsIs: false
});

require("./PaymentStatusInfo.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./PaymentStatusInfo.tsx");